import { render, staticRenderFns } from "./BusinessPlanVersion.vue?vue&type=template&id=bfd6b5a0&"
import script from "./BusinessPlanVersion.vue?vue&type=script&lang=js&"
export * from "./BusinessPlanVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports